import { queryClient } from "api/setup";
import { store } from "store";

export const logoutAction = () => {
  queryClient.clear();
  store.dispatch({ type: "USER_LOGOUT" });
};
